export const friendlyDate = date => {
  const timestamp = Date.parse(date);
  if (isNaN(timestamp)) {
    return undefined;
  }

  if (timestamp < 0) {
    return 'Never';
  }

  const returnDate = new Date(date);
  return returnDate.toLocaleDateString() + ' ' + returnDate.toLocaleTimeString();
};


// WEBPACK FOOTER //
// src/helpers/date.js